import { useContext } from 'react';

import { ServerSheetContext, type ServerSheetContextValue } from '../contexts/server-sheet-context';

export function useServerSheet(): ServerSheetContextValue {
  const context = useContext(ServerSheetContext);
  if (!context) {
    throw new Error('useServerSheet must be used within a ServerSheetProvider');
  }
  return context;
}
